import { IconAlertTriangleFilled, IconBan } from "@tabler/icons-react";
import React from "react";
import {
	LexWorkplaceArchiveIcon,
	LexWorkplaceTrashIcon,
} from "../LexWorkplaceIcons";

function humanReadableList(items) {
	if (!Array.isArray(items)) {
		// if not an array just return false
		return false;
	}

	if (items.length === 0) return "";
	if (items.length === 1) return items[0];
	if (items.length === 2) return `${items[0]} or ${items[1]}`;

	const allButLast = items.slice(0, -1).join(", ");
	const last = items[items.length - 1];
	return `${allButLast}, or ${last}`;
}

const TrashOrArchiveBinMessageForDocumentOrNote = ({
	IN_TRASH,
	IN_ARCHIVE,
	itemType,
	itemLocation,
	objectType = "",
}) => {
	let message = "";
	let operation = "edit";
	if (!objectType) {
		console.warn(
			'TrashOrArchiveBinMessageForDocumentOrNote: objectType is not provided, defaulting to "Document"'
		);
		objectType = "Document";
	}
	if (objectType === "Document") {
		operation = "open or edit";
	}

	let location;
	let iconComponent = null;
	let undoVerb;

	if (IN_TRASH) {
		location = `in the ${itemLocation}`;
		undoVerb = "restore";
		iconComponent = <LexWorkplaceTrashIcon />;
	} else if (IN_ARCHIVE) {
		location = `in the ${itemLocation}`;
		undoVerb = "Unarchive";
		iconComponent = <LexWorkplaceArchiveIcon />;
	}
	if (["Matter", "Folder"].includes(itemType)) {
		message = `The ${itemType} for this ${objectType} is ${location}. You must ${undoVerb} the ${itemType} before you ${operation} ${objectType}s within it.`;
	} else {
		message = `This ${itemType} is ${location}. You must ${undoVerb} the ${itemType} before you can ${operation} it.`;
	}

	return (
		<div
			className={`belowSubHeaderWarning noDefaultMargin ${IN_ARCHIVE ? "Archive" : IN_TRASH ? "Trash" : ""}`}
		>
			{iconComponent}
			<div>{message}</div>
		</div>
	);
};

function getTrashBinMessage({
	objectType,
	deniedOperationsArray,
	itemLocation,
}) {
	// this part of the message is always here
	let trashBinMessage = `This ${objectType} is in the ${itemLocation}. `;

	let deniedActionsString = humanReadableList(deniedOperationsArray);

	const undoVerb = itemLocation === "Trash Bin" ? "restore" : "Unarchive";

	if (deniedActionsString) {
		trashBinMessage += `You must ${undoVerb} the ${objectType} before you can ${deniedActionsString}.`;
	} else {
		trashBinMessage += `You must ${undoVerb} the ${objectType} before you can edit it.`;
	}
	return trashBinMessage;
}

const TrashBinMessage = ({
	objectType,
	deniedOperationsArray,
	itemLocation,
}) => {
	const allowedItemLocations = ["Trash Bin", "Archive"];
	if (!allowedItemLocations.includes(itemLocation)) {
		console.error(
			`TrashBinMessage: itemLocation must be one of ${allowedItemLocations.join(
				", "
			)}. Received: ${itemLocation}`
		);
		return null;
	}

	let trashBinMessage = getTrashBinMessage({
		objectType,
		deniedOperationsArray,
		itemLocation,
	});
	return (
		<div
			className={`belowSubHeaderWarning ${itemLocation} noDefaultMargin`}
		>
			{itemLocation === "Archive" ? (
				<LexWorkplaceArchiveIcon />
			) : (
				<LexWorkplaceTrashIcon />
			)}
			<div>{trashBinMessage}</div>
		</div>
	);
};

const SuspendedFirmMessage = () => {
	return (
		<div className="belowSubHeaderWarning noDefaultMargin">
			<IconBan size={20} />
			<div>This firm is suspended - it cannot be edited</div>
		</div>
	);
};

const SuspendedFirmUsersMessage = () => {
	return (
		<div className="belowSubHeaderWarning noDefaultMargin">
			<IconBan size={20} />
			<div>This firm is suspended. Users cannot be added or edited</div>
		</div>
	);
};

const AbbreviatedDocumentListDataMessage = () => {
	return (
		<div className="belowSubHeaderWarning noDefaultMargin">
			<IconAlertTriangleFilled size={20} />
			<div>{`This folder contains too many items to load all columns. We're only displaying the Name and ID for each item.  For help with reorganizing this folder, please contact LexWorkplace Support.`}</div>
		</div>
	);
};

export {
	TrashBinMessage,
	TrashOrArchiveBinMessageForDocumentOrNote,
	AbbreviatedDocumentListDataMessage,
	SuspendedFirmMessage,
	SuspendedFirmUsersMessage,
};
